import { Grid } from "@mui/material";
import React, { Children } from "react";

interface MxDetailCardProps {
  children: any;
  id?: string;
  sx?: any;
}
const MxDetailCard = (props: MxDetailCardProps) => {
  return (
    <Grid
      id={props.id}
      container
      item
      sx={props.sx}
      xs={12}
      borderRadius={1}
      bgcolor="background.paper"
      px={4}
      py={3}
    >
      {props.children}
    </Grid>
  );
};

export default MxDetailCard;
